/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FiChevronRight } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";

const TotalEarning = () => {
  const [totalEarningActiveTab, setTotalEarningActiveTab] =
    useState("Scheduled");

  const location = useLocation();
  const navigate = useNavigate();
  const providerId = location.state?.providerId;
  const providerName = location.state?.providerName;
  const [totalEarnings, setTotalEarnings] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCompleteAppoinments = async () => {
    try {
      const response = await getApiCaller(
        `provider_appointment_list?provider_id=${providerId}`
      );
      setTotalEarnings(response.data.response_data);
    } catch (error) {
      toast.error("Failed to fetch pending providers. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    providerId && fetchCompleteAppoinments();
  }, [providerId]);

  const getDateTime = (date, time) => {
    const endTime = time.split("-").pop().trim();
    const dateTimeString = `${date} ${endTime}`;

    // Parse date string to a moment object
    return moment(dateTimeString, "DD-MM-YYYY hA");
  };

  const filteredEarnings = totalEarnings?.length
    ? totalEarnings.filter((earning) => {
        const isFutureDate = getDateTime(earning?.datee, earning.time).isAfter(
          moment()
        );

        const isBeforeDate = getDateTime(earning?.datee, earning.time).isBefore(
          moment()
        );

        if (totalEarningActiveTab === "Scheduled") {
          return (
            earning?.booking_status === "Confirmed" &&
            earning?.status === "Approved" &&
            isFutureDate
          );
        } else if (totalEarningActiveTab === "In-Process") {
          return (
            earning?.booking_status === "Confirmed" &&
            earning?.status === "Approved" &&
            isBeforeDate
          );
        } else if (totalEarningActiveTab === "Paid") {
          return (
            earning?.booking_status === "Complete" &&
            earning?.status === "Approved"
          );
        }

        return false;
      })
    : [];

  const totalWalletBalance =
    filteredEarnings &&
    filteredEarnings?.reduce((sum, earning) => sum + earning.amount, 0);

  return (
    <>
      <div className="px-4 md:px-10 mt-4">
        <nav className="flex flex-col sm:flex-row sm:items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            <a
              href="/provider"
              className="text-[#284184] text-xl hover:underline"
            >
              All Providers
            </a>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <button
              href="/provider"
              className="text-[#284184] text-xl font-[Lato-Regular] hover:underline"
              onClick={() =>
                navigate("/providerProfile", {
                  state: { provider: { id: providerId } },
                })
              }
            >
              {providerName}
            </button>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <span className="text-[#284184] text-xl font-[Lato-Regular] font-bold">
              Total Earning
            </span>
          </div>
          <div className="flex mt-3 sm:mt-0 space-x-3">
            <button className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600">
              Load Wallet
            </button>
            <button className="bg-blue-700 text-white px-4 py-2 rounded-md hover:bg-blue-800">
              Send Notification
            </button>
          </div>
        </nav>
        {/* Total Earning */}
        <div className="border border-1 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
          <p className="text-[#284184] font-bold">Total Earning</p>
        </div>
        <div className="border border-t-0 rounded-b-2xl px-2 pt-4 bg-white">
          <div className="flex w-full rounded-lg bg-[#F4F9FF] p-1">
            {["Scheduled", "In-Process", "Paid"].map((tab) => (
              <button
                key={tab}
                className={`w-full px-4 py-2 text-[#80838D] rounded-lg text-left md:text-center ${
                  totalEarningActiveTab === tab && "bg-[#284184] text-white"
                }`}
                onClick={() => setTotalEarningActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          {loading ? (
            <div className="text-center text-blue-500 h-[50vh] flex justify-center items-center">
              <PropagateLoader color="#284184" loading={true} size={10} />
            </div>
          ) : (
            <div className="px-2 mt-4">
              <div className="flex justify-center border bg-white rounded-lg shadow-sm p-6 mb-4">
                <div className="text-center">
                  <p className="text-4xl font-semibold text-[#E0A256]">
                    ${totalWalletBalance || 0}
                  </p>
                  <button className="text-blue-600 text-sm mt-2">
                    REEBUK Health Wallet
                  </button>
                </div>
              </div>

              {/* Transactions */}
              <div className="bg-white rounded-lg shadow-sm">
                <div className="divide-y border rounded-xl mb-2">
                  {filteredEarnings?.length === 0 ? (
                    <p className="text-center text-gray-500 h-[50vh] flex justify-center items-center">
                      No {totalEarningActiveTab} data available
                    </p>
                  ) : (
                    filteredEarnings &&
                    filteredEarnings?.map((earning) => (
                      <div
                        key={earning?.booking_id}
                        className="px-4 py-3 hover:bg-gray-50"
                      >
                        <div className="flex justify-between items-center">
                          <div className="flex gap-3">
                            <img
                              src={
                                earning?.profile_picture ||
                                `https://c8.alamy.com/comp/KEDB24/handsome-young-man-profile-KEDB24.jpg`
                              }
                              alt={"profile"}
                              className="w-12 h-12 rounded-xl"
                            />
                            <div>
                              <h3 className="text-sm font-semibold text-gray-900">
                                {earning?.patient_name}
                              </h3>
                              {earning?.date && (
                                <p className="text-sm text-[#496ECC] mt-1">
                                  {moment(earning?.date, "DD-MM-YYYY").format(
                                    "DD[th] ddd"
                                  )}
                                  , {earning?.time}
                                </p>
                              )}
                            </div>
                          </div>
                          <span
                            className={`text-xl text-[#284184] font-semibold`}
                          >
                            ${earning?.amount || 0}
                          </span>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TotalEarning;
